import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss', '../../related-content/related-content.component.scss']
})
export class UserListComponent {
  @Input() users: any;
  @Input() panelTitle: any = 'Attendees';
}
